export const takeMessage = () => ({
  type: 'snapshot:take'
})

export const dismissMessage = () => ({
  type: 'snapshot:dismiss'
})

export const downloadMessage = () => ({
  type: 'snapshot:download'
})

export const downloadThumbnailMessage = () => ({
  type: 'snapshot:download-thumbnail'
})

export const saveMessage = (data) => ({
  ...data,
  type: 'snapshot:save',
})

export const boardMessage = (data) => ({
  ...data,
  type: 'snapshot:board',
})

export const cancelSnapshotMessage = () => ({
  type: 'snapshot:cancel'
})

export const createTemporaryUploadLink = () => ({
  method: 'snapshot:createTemporaryUploadLink',
  params: {}
})

export const createTemporaryDownloadLink = (isThumbnail) => ({
  method: 'snapshot:createTemporaryDownloadLink',
  params: { isThumbnail: !!isThumbnail }
})

export const deleteTemporarySnapshot = () => ({
  method: 'snapshot:deleteTemporarySnapshot',
  params: {}
})

export const createUploadLink = () => ({
  method: 'snapshot:createUploadLink',
  params: {}
})